import React from 'react';
import PolicyPage from './PolicyPage';

const sections = [
  {
    heading: 'Initial Resolution',
    paragraphs: [
      'If you have a dispute relating to a transaction, service, or website use, please contact TUR DER HOFFNUNG first so we can review and attempt to resolve the issue directly and in good faith.',
      'Please provide all relevant details, including transaction references, dates, and supporting explanation, so we can investigate efficiently.',
    ],
  },
  {
    heading: 'Review Procedure',
    paragraphs: [
      'We will review dispute submissions internally and may request additional information where needed. Our goal is to provide a reasonable response and resolution path within a practical timeframe.',
      'Where applicable, we may coordinate with payment processors or service partners to verify transaction data and settlement records.',
    ],
  },
  {
    heading: 'Escalation',
    paragraphs: [
      'If a dispute cannot be resolved directly, the matter may be escalated through the relevant payment provider, financial institution, or legal process available under applicable law.',
      'Nothing in this policy limits any rights that cannot legally be excluded.',
    ],
  },
];

export default function DisputeResolutionPage() {
  return (
    <PolicyPage
      title="Dispute Resolution Policy"
      subtitle="Dispute Resolution"
      sections={sections}
    />
  );
}
